import { useSyncExternalStore } from 'react';

export type Breakpoint = 'phone' | 'tablet' | 'desktop';

/* Must match --breakpoint-sm / --breakpoint-lg in styles/theme.css: phone ≤ 640, tablet 641–1024, desktop ≥ 1025. */
const DESKTOP = '(min-width: 1025px)';
const TABLET = '(min-width: 641px)';

function read(): Breakpoint {
  if (typeof window === 'undefined') return 'desktop';
  if (window.matchMedia(DESKTOP).matches) return 'desktop';
  if (window.matchMedia(TABLET).matches) return 'tablet';
  return 'phone';
}

function subscribe(onChange: () => void): () => void {
  const lists = [window.matchMedia(DESKTOP), window.matchMedia(TABLET)];
  for (const l of lists) l.addEventListener('change', onChange);
  return () => {
    for (const l of lists) l.removeEventListener('change', onChange);
  };
}

/** One shell variant is mounted at a time (no duplicated DOM/testids across hidden variants). */
export function useBreakpoint(): Breakpoint {
  return useSyncExternalStore(subscribe, read, () => 'desktop');
}
